import { Component, Injector } from '@angular/core';
import { ClassificationTypeService, DocRole } from '@digiwall/goliath-core/proxy';
import { BaseStockDocDetailHelperService } from '../../../base-docs/detail/base-stock-doc-detail';
import {
  CreateStockDocInventoryDto,
  DayBookService,
  StockDocDefaultValueDto,
  StockDocInventoryDto,
  StockDocInventoryService,
} from '@digiwall/goliath-documents/proxy';
import StockDocInventoryLinesEditorComponent from './stock-doc-inventory-lines/stock-doc-inventory-lines-editor.component';
import {
  StockDocDetailComponent,
  StockDocDetailComponentImports,
  StockDocDetailComponentProviders,
} from '../../stock-doc-detail.component';
import { DocTemplateService } from '../../../base-docs/detail/doc-template-selection/doc-template.service';
import { SubscriptionService, LocalizationService, ConfigStateService } from '@abp/ng.core';
import { ToasterService, ConfirmationService } from '@abp/ng.theme.shared';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeactivatableComponentService } from '@digiwall/core';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'document-stock-doc-inventory-detail',
  templateUrl: './stock-doc-inventory-detail.component.html',
  providers: [BaseStockDocDetailHelperService, ...StockDocDetailComponentProviders],
  imports: [StockDocInventoryLinesEditorComponent, ...StockDocDetailComponentImports],
})
export class StockDocInventoryDetailComponent extends StockDocDetailComponent<
  StockDocInventoryService,
  StockDocInventoryDto,
  CreateStockDocInventoryDto,
  StockDocDefaultValueDto
> {
  override get docRole() {
    return DocRole.StockDocInventory;
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    docService: StockDocInventoryService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    docTemplateService: DocTemplateService,
    injector: Injector,
    config: ConfigStateService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      docService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      config,
      confirmationService,
      deactivableComponentService,
    );
  }
}
